import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import styles from './partner.module.scss';

const PartnerCell = ({ value }: Partial<ICellRendererParams>) => {
  let partner: any = {};
  const unkownPartner = 'Player';

  /* Loop through the players and render the names - exclude this player */
  if (value?.players?.length) {
    partner = value.players.find(
      (player: any) => player.person?.personID !== value?.thisPlayerId
    );
  }

  const isPartnerUnknown =
    partner?.person?.nativeGivenName === 'UNKNOWN' ||
    partner?.person?.nativeFamilyName === 'UNKNOWN';
  const partnerFullName = partner?.person?.nativeGivenName
    ? `${partner.person.nativeGivenName} ${partner.person.nativeFamilyName}`
    : unkownPartner;
  const partnerValue = isPartnerUnknown ? unkownPartner : partnerFullName;

  return (
    <span className={styles.partner} title={partnerValue}>
      {partnerValue}
    </span>
  );
};

export { PartnerCell };
